// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import React from "react";
import { Alert, Button } from "antd";
const permissions = {
  admin: ["read", "edit", "delete"],
  bursar: ["read", "edit"],
  staff: ["read"],
};
function PermissionChecker(props) {
  const checkUserRole = () => {
    return props.user.role;
  };

  const checkIfUserHasPermissions = (permission) => {
    let role = checkUserRole();
    if (role && permissions[role]) {
      let ifPermitted = permissions[role].includes(permission);

      if (ifPermitted) {
        return true;
      }
    }

    return false;
  };

  return checkIfUserHasPermissions(props.permission) ? (
    <> {props.children} </>
  ) : (
    <div>
      {!checkUserRole() ? (
        <Alert
          message="Sorry"
          description={
            <>
              <p>You don't have the permission.</p>
              <Button>
                <a href="https://libi-textbooks.herokuapp.com/sso/login">
                  Log in
                </a>
              </Button>
            </>
          }
          type="info"
          showIcon
        />
      ) : (
        <></>
      )}
    </div>
  );
}

export default PermissionChecker;
